export default function ReadCTA() {
  return (
    <section
      data-testid="read-cta-section"
      aria-label="Mini-Series Coming Soon"
      className="relative flex min-h-[220px] items-center justify-center bg-neon px-6 py-12 sm:min-h-[260px] sm:px-12"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to bottom, transparent 0px, transparent 3px, rgba(0, 0, 0, 0.4) 3px, rgba(0, 0, 0, 0.4) 4px)",
        }}
      />
      <span
        data-testid="read-miniseries-cta"
        className="inline-flex items-center gap-3 border-2 border-black bg-transparent px-8 py-4 font-mono text-sm font-bold uppercase tracking-[0.2em] text-black"
      >
        Mini-Series Coming Soon
      </span>
    </section>
  );
}
